<drawer *ngIf="documentRequirement" [title]="showDeterminantBuilder ? 'Requirement - Determinant' : documentRequirement.id ? 'Edit Requirement' : 'Add Requirement'"
	[showHeaderButtons]="true"
	[hideDelete]="true"
	[hideCancel]="false"
	[hideSave]="false"
	[noContentPadding]="showDeterminantBuilder"
	[isClosed]="false"
	[contextLabel]="documentRequirement?.requirement?.name || ('Requirement ' + (documentRequirement.id ? documentRequirement.id : ''))"
	(saveEvent)="submit()"
	(cancelEvent)="closeLayer()"
	(closeEvent)="closeLayer()">
	<div class="drawer-content drawer-direct-content">
		<div *ngIf="showDeterminantBuilder" class="d-flex overflow-hidden mh-100 h-100 w-100">
			<determinant-new
				*ngIf="store.state.common.determinantSection.topLayer === 'edit'"
				class="d-flex overflow-hidden mh-100 w-100 flex-column"
				[serviceId]="serviceId"
				[determinant]="store.state.common.determinantSection.determinant"
				[isEmbedded]="false"
				[isClosed]="false"
				(formSubmit)="closeDetLayer()"
				(editCancel)="closeDetLayer()"
			></determinant-new>
			<div class="overflow-hidden mh-100 h-100 w-100 {{store.state.common.determinantSection.topLayer === 'edit' ? 'd-none' : 'd-flex'}} flex-column">
				<div class="mb-0 no-gutters row h-100 overflow-hidden w-100">
					<div class="col list-determinants h-100 mh-100">
						<determinant-list
							class="d-flex overflow-hidden mh-100 h-100 flex-column flex-grow-0 py-3 pl-3"
							[groupsLength]="{value: documentRequirement.jsonDeterminants}"
							[prefix]="'rese'"
							[determinantMapById]="determinantMapById"
							[addDeterminantTo]="appendDeterminant"></determinant-list>
					</div>
					<div class="col pl-2 pb-3 query-builder">
						<query-builder *ngIf="documentRequirement" [determinantMapById]="determinantMapById"
							[ngClass]="'fixed scrolleable'"
							[prefix]="'rese'"
							[jsonString]="documentRequirement.jsonDeterminants"
							(onChange)="documentRequirement.jsonDeterminants = $event.jsonString"></query-builder>
					</div>
				</div>
			</div>
		</div>
		
		<div *ngIf="!showDeterminantBuilder" class="row">
			<div class="col-12">
				<form name="itemForm" role="form">

					<div class="d-flex my-4 py-2 row fields-group {{ showDeterminantBuilder ? 'hidden' : '' }}">
						<div class="col align-items-center d-flex pl-0">
							<span (click)="changeUploadSettings()" tooltip="{{ 'modal.requirement_to_upload' | translate }}" placement="right">
								<span class="btn btn-circle-medium btn-circle-icon mr-2 btn-pink btn-toggle {{ isFieldDisabled(requirement.ownership) ? 'disabled' : '' }} {{
									documentRequirement.toUpload ? 'active' : '' }}"><i class="far fa-file-arrow-up"></i></span>
								</span>
							<span (click)="changeShowAtFrontDeskSettings()" tooltip="{{ 'modal.requirement_to_show' | translate }}" placement="right">
								<span class="btn btn-circle-medium btn-circle-icon mr-2 btn-success btn-toggle {{ isFieldDisabled(requirement.ownership) ? 'disabled' : '' }} {{
									documentRequirement.toShow ? 'active' : '' }}"><i class="far fa-id-card"></i></span>
							</span>
							<span (click)="changeMustBeSignedSettings()" tooltip="{{ 'modal.requirement_to_sign' | translate }}" placement="right">
								<span class="btn btn-circle-medium btn-circle-icon mr-2 btn-primary btn-toggle {{ isFieldDisabled(requirement.ownership) ? 'disabled' : '' }} {{
									documentRequirement.toSign ? 'active' : '' }}"><i class="far fa-signature"></i></span>
							</span>
							<span (click)="changeMultipleSettings()" tooltip="{{ 'modal.requirement_is_multiple' | translate }}" placement="right">
								<span class="btn btn-circle-medium btn-circle-icon mr-2 btn-secondary btn-toggle {{ isFieldDisabled(requirement.ownership) ? 'disabled' : '' }} {{
									documentRequirement.multiple ? 'active' : '' }}">
									<i class="fa-solid fa-files"></i>
								</span>
							</span>
							<span *ngIf="documentRequirement.linkingFileUploadPath"
								tooltip="{{ 'modal.requirement_is_linked_with_file_upload_component' | translate }} - {{ documentRequirement.linkingFileUploadPath }}"
								placement="right">
								<span class="btn btn-circle-medium btn-circle-icon mr-2 btn-danger" [routerLink]="documentRequirement.linkingFileUploadPathRouterLink">L</span>
							</span>
							<span *ngIf="documentRequirement && requirement.id" (click)="changeUsedAsADatabase()" tooltip="{{ 'Create Model document' | translate }}" placement="right">
								<span class="btn btn-circle-medium btn-circle-icon mr-2 btn-purple {{
									documentRequirement.usedAsADatabase ? 'active' : '' }}">
									<i class="fa-solid fa-wand-magic-sparkles"></i>
								</span>
							</span>
						</div>
						<div class="col-auto page-actions-container py-0 d-flex align-items-center px-1">
							<a *ngIf="requirement && requirement.fileId"
								(click)="download(requirement)"
								download
								class="btn btn-circle-small btn-circle-icon btn-light">
								<i tooltip="{{ 'Download file' | translate }}"
									placement="left" class="fal fa-file"></i>
							</a>
							<label class="btn-light btn btn-circle-small btn-circle-icon mx-1">
								<i tooltip="{{ 'Upload or change uploaded file' | translate }}" placement="left" class="{{requirement ? 'far fa-pen' : 'fal fa-file'}}"></i>
								<file-uploader
									[item]="requirement"
									(fileIdChanged)="handleUpload($event, requirement)"
								></file-uploader>
							</label>
							<a *ngIf="requirement && requirement.fileId"
								class="btn-bordered btn-danger btn-icon btn-xs d-flex align-items-center"
								(click)="deleteFile(requirement, this.deleteDefaultCb)">
								<i tooltip="{{ 'Erase file' | translate }}"placement="left" class="fas fa-times"></i>
							</a>
						</div>
						<div class="col-auto align-items-center d-flex pr-0" *ngIf="documentRequirement?.requirement?.businessKey" >
							<business-key
								[businessKey]="documentRequirement?.requirement?.businessKey"
								[businessKeyTooltip]="'Result business key' | translate"></business-key>
						</div>
					</div>

					<div class="row fields-group">
						<div class="col">
							<div class="row mb-4">
								<div class="col">
									<label class="input-label field-required">{{'Requirement name' | translate}}</label>
									<input class="form-control"
										placeholder="{{ 'Requirement name' | translate }}"
										[(ngModel)]="requirement.name"
										[disabled] = "isFieldDisabled(requirement.ownership)"
										type="text"
										name="requirementName"
										#requirementName="ngModel"
										[rangeLength]="[2, 256]"
										required
										(focus)="checkErrors = false"
										(blur)="checkErrors = true"
										autofocus/>
									<p class="validation-error" *ngIf="checkErrors && requirementName && requirementName.errors && requirementName.errors?.required && requirementName?.touched">{{ 'form.validate.required' | translate }}</p>
									<p class="validation-error" *ngIf="checkErrors && requirementName && requirementName.errors?.rangeLength">{{ 'form.validate.minLenght' | translate }} 2!</p>
									<p class="validation-error" *ngIf="checkErrors && requirementName && requirementName.errors?.rangeLength">{{ 'form.validate.maxLenght' | translate }} 256!</p>
								</div>
							</div>
						
			
							<div class="row">
								<div class="col">
									<label class="input-label">{{'modal.comment_in_context' | translate}}</label>
									<textarea class="form-control"
										name="additionalInformation"
										[(ngModel)]="documentRequirement.additionalInformation"
										[disabled] = "isFieldDisabled(requirement.ownership)"
										rows="1"></textarea>
								</div>
							</div>
						</div>
					</div>

					<div *ngIf="documentRequirement.usedAsADatabase" class="row fields-group faded">
						<div class="col-12">
							<label class="input-label">{{ 'Create Model document' | translate }}</label>
							<p>{{'The requirement name defines what is needed (e.g. Passport). The model name defines a specific document format for that requirement (e.g. French Passport, US Passport). In the future, multiple models will be allowed per requirement. For now, only one model can be created, but it helps define the structure and validation of the document.' | translate}}</p>
							<file-handler
								[accept]="'.pdf,.jpg,.jpeg,.png,.tiff,.tif,.bmp,.heic,.heif'"
								[uploadPath]="getTemplateUrl()"
								[fileId]="documentRequirement.templateUrl"
								(fileIdChanged)="templateUrlChanged($event)"
								(delete)="deleteTemplate(true)">
							</file-handler>
							<div class="row" *ngIf="documentRequirement?.usedAsADatabase && (documentRequirement?.templateUrl && documentRequirementFields?.length < 1)">
								<div class="col">
									<button class="btn d-block magic-background text-white w-100 mt-3" (click)="getDocumentFields(documentRequirement.id);">
										<span *ngIf="!analysing"><i class="far fa-sparkles mr-2"></i>{{ "Create template with AI" |	translate }}</span>
										<span *ngIf="analysing"><i class="far fa-spinner-third fa-spin mr-2"></i>{{ "Analysing..." |	translate }}</span>
									</button> 
								</div>
							</div>
						</div>
					
						<ng-container *ngIf="documentRequirement?.usedAsADatabase && (documentRequirement?.templateUrl && documentRequirementFields?.length > 0)">
							<!--
							<div class="col-5 align-items-center justify-content-start">
								<service-file-uploader [serviceUrl]="getTemplateUrl()" (fileIdChanged)="templateUrlChanged($event)"></service-file-uploader>
							</div>
							-->
							<!--div class="col-5 align-items-center justify-content-start">
							<img *ngIf="logoUrl" src="{{ logoUrl }}" class="img-thumbnail" style="max-height: 64px;" />
							</div>
							<div class="col-2 align-items-center justify-content-end" *ngIf="this.documentRequirement && this.documentRequirement.templateUrl">
							<confirmation [buttonName]="'general.delete'" [question]="'confirm.areyousure'" [showTrashIcon]="true" (isConfirmed)="deleteTemplate($event)">
							</confirmation>
							<div>
								<strong>Name:</strong>
								{{ this.documentRequirement.aiSchemaName }}
							</div>
							<div>
								<strong>Description:</strong>
								{{ this.documentRequirement.aiSchemaDescription }}
							</div>
							</div>
							-->
							<div class="col-12">
								<label class="input-label">{{'Model name' | translate}}</label>
								<input class="form-control"
									placeholder="{{ 'Model name' | translate }}"
									[(ngModel)]="documentRequirement.aiSchemaName"
									[disabled] = "isFieldDisabled(requirement.ownership)"
									type="text"
									name="docName"
									#docName="ngModel"
									[rangeLength]="[2, 256]"
									required
									autofocus/>
								<label class="input-label mt-3">{{'Model description' | translate}}</label>
								<textarea class="form-control"
									name="docNameAdditionalInformation"
									[(ngModel)]="documentRequirement.aiSchemaDescription"
									[disabled] = "isFieldDisabled(requirement.ownership)"
									rows="2"></textarea>
							</div>

							<div class="col-12">
								<p>{{'Mark which fields must be present for the document to be valid, and which should be extracted as service data' | translate}}</p>
								<table class="table align-middle effects-table mb-0">
									<thead>
										<tr>
											<th></th>
											<th style="width: 25%;">{{ 'Field name' | translate }}</th>
											<th style="width: 25%;">{{ 'Type' | translate }}</th>
											<th style="width: 20%;">{{ 'Working label' | translate }}</th>
											<th class="toggle-column" tooltip="{{ 'The field must be present and readable for the document to be considered valid.' | translate }}">{{ 'Needed for validity' | translate }}</th>
											<th class="toggle-column" tooltip="{{ 'The field will be extracted and added to the service data.' | translate }}">{{ 'Include in service data' | translate }}</th>
											<th></th>
										</tr>
									</thead>
									<tbody cdkDropList [cdkDropListData]="documentRequirementFields" cdkDropListLockAxis="y" (cdkDropListDropped)="onFieldDrop($event)">
										<ng-container *ngFor="let item of documentRequirementFields">
											<tr cdkDrag cdkDragLockAxis="y" class="document-field-row">
												<td cdkDragHandle class="drag-handle"><i class="fa-solid fa-grip-dots"></i></td>
												<td>
													<input type="text" class="form-control" name="fieldName{{item.id}}" [(ngModel)]="item.fieldName" (blur)="updateDocumentRequirementField(item)" />
												</td>
												<td>
													<select [(ngModel)]="item.fieldType" class="form-control" name="fieldType{{item.id}}" (change)="updateDocumentRequirementField(item)">
														<option *ngFor="let type of fieldTypes" [ngValue]="type">{{ type }}</option>
													</select>
												</td>
												<td>
													<input type="text" class="form-control" name="workingLabel{{item.id}}" [(ngModel)]="item.workingLabel" (blur)="updateDocumentRequirementField(item)" />
												</td>
												<td class="text-center"><toggle-buttons [toggleIcons]="true" [iconsType]="'check'" [value]="item.validationRequired" (changed)="item.validationRequired = $event; updateDocumentRequirementField(item)"></toggle-buttons></td>
												<td class="text-center"><toggle-buttons [toggleIcons]="true" [iconsType]="'toggle'" [value]="item.useInSfl" (changed)="item.useInSfl = $event; updateDocumentRequirementField(item)"></toggle-buttons></td>
												<td>
													<i (click)="deleteDocumentRequirementField(item)" class="btn-xs btn-bordered btn-danger btn-icon fas fa-times mr-2" tooltip="{{ 'Delete field' | translate }}" placement="left"></i>
												</td>
											</tr>
										</ng-container>
										<tr *ngIf="documentRequirementField">
											<td></td>
											<td><input type="text" class="form-control" name="fieldName" [(ngModel)]="documentRequirementField.fieldName" /></td>
											<td>
												<select [(ngModel)]="documentRequirementField.fieldType" class="form-control" name="fieldType">
													<option *ngFor="let type of fieldTypes" [ngValue]="type">{{ type }}</option>
												</select>
											</td>
											<td>
												<input type="text" class="form-control" name="workingLabel" [(ngModel)]="documentRequirementField.workingLabel" />
											</td>
											<td class="text-center"><toggle-buttons [toggleIcons]="true" [iconsType]="'check'" [value]="documentRequirementField.validationRequired" (changed)="documentRequirementField.validationRequired = $event;"></toggle-buttons></td>
											<td class="text-center"><toggle-buttons [toggleIcons]="true" [iconsType]="'toggle'" [value]="documentRequirementField.useInSfl" (changed)="documentRequirementField.useInSfl = $event;"></toggle-buttons></td>
											<td>
												<a class="" (click)="saveDocumentRequirementField(documentRequirementField)">
													<i class="fas fa-plus mr-2" tooltip="{{ 'Add field' | translate }}" placement="left"></i>
												</a>
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</ng-container>
					</div>
			
					<div *ngIf="showBotSelection()" class="row fields-group">
						<div class="col">
							<div class="row">
								<div class="col">
									<label class="input-label">{{ 'Document bot' | translate }}</label>
								</div>
							</div>
							<div class="row align-items-center">
								<div class="col" *ngIf="availableDocumentBots.length > 0">
									<select class="form-control ng-pristine ng-invalid ng-invalid-required ng-touched mr-auto"
										[(ngModel)]="documentRequirement.bot" nameFieldKey="title" name="bot">
										<option [ngValue]="null"></option>
										<option *ngFor="let bot of availableDocumentBots" [ngValue]="bot">{{bot.name}}</option>
									</select>
								</div>
					
								<div class="col-auto">
									<a class="btn btn-primary" target="_blank" [routerLink]="['/services/' + serviceId + '/bots']">
										<span>{{ 'Create new bot' | translate }}</span>
									</a>
								</div>
							</div>
						</div>
					</div>

				</form>
			</div>
		</div>
	</div>
</drawer>
